import React, { PureComponent } from "react"
import { FadeIn } from "animate-css-styled-components"
import ScrollableAnchor, { configureAnchors } from "react-scrollable-anchor"
import { Link } from "react-router-dom"
import qs from "query-string"
import { compose } from "recompose"
import { injectIntl } from "react-intl"
import Box from "../../lib/ui/ui-box"
import Navigation from "../../components/navigation"
import Hero from "../../components/hero"
import LogosRow from "../../components/logos-row"
import WhoCanApply from "../../components/who-can-apply"
import HowItWorks from "../../components/how-it-works"
import Footer from "../../components/footer"
import WithSizes from "../../hocs/with-sizes.hoc"
import MenuToggle from "../../components/mobile-menu-toggle"
import MobileMenuWrapper from "../../components/mobile-menu-manager/mobile-menu-wrapper.component"
import Logo from "../../components/logo"

class Container extends PureComponent {
  state = {
    isMenuToggled: false,
    heroCopy: "Best Mortgage Rate. Period.",
    rate: true,
    simple: false
  }
  componentWillMount() {
    const { location } = this.props
    const { utm_content } = qs.parse(location.search)
    this.setState({ utm_content })

    const SIMPLE = "hero.simple"
    const RATE = "hero.rate"

    configureAnchors({
      offset: -60,
      scrollDuration: 500,
      keepLastAnchorHash: true
    })

    switch (utm_content) {
      case "Amortization":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Closed-Mortgage":
        return this.setState({ heroCopy: RATE, simple: false })
      case "First-time-buyer":
        return this.setState({ heroCopy: SIMPLE, simple: true })
      case "Fixed-Mortage-Rate":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Fixed-Mortgage-Rate":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Generic-Mortgage":
        return this.setState({ heroCopy: SIMPLE, simple: true })
      case "Generic-Mortgage-Calculator":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Mortgage-Broker":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Mortgage-Companies":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Mortgage-Consultant":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Mortgage-Deals":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Variable-Mortgage-Rate":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Variable-Mortage-Rate":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Mortgage-Rates":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Self-Employed":
        return this.setState({ heroCopy: SIMPLE, simple: true })
      case "Competitors":
        return this.setState({ heroCopy: RATE, simple: false })
      case "Nesto":
        return this.setState({ heroCopy: SIMPLE, simple: true })
      default:
        return this.setState({ heroCopy: RATE, simple: false })
    }
  }

  toggleMenu = () => this.setState({ isMenuToggled: !this.state.isMenuToggled })

  render() {
    const { isDesktopAndGreater } = this.props
    return (
      <Box w={[1, 1, 1, 1]} flexDirection="column" bg="white">
        {!isDesktopAndGreater && <MenuToggle onClick={this.toggleMenu} />}
        {isDesktopAndGreater && <Navigation {...this.props} />}
        {!isDesktopAndGreater &&
          this.state.isMenuToggled && (
            <MobileMenuWrapper>
              <Navigation {...this.props} />
            </MobileMenuWrapper>
          )}
        {this.props.isMobile && (
          <Box pt={[5]} align="center" justify="center">
            <Link to="/" style={{ display: "flex", alignItems: "center" }}>
              <Box flexDirection="column" align="center" pl={[1]}>
                <Logo src="/logo/Nesto_Equity_Logo.png" alt="Nesto Logo" />
              </Box>
            </Link>
          </Box>
        )}
        <Hero {...this.state} {...this.props} />
        <FadeIn duration="0.25s" delay="0.9s">
          <Box bg="white" justify="center" flexDirection="column">
            {/* Landing Page */}
            <LogosRow />
            <WhoCanApply />
            <ScrollableAnchor id="how-it-works">
              <ScrollableAnchor id="notre-approche">
                <div>
                  <HowItWorks />
                </div>
              </ScrollableAnchor>
            </ScrollableAnchor>
            <Footer {...this.props} />
          </Box>
        </FadeIn>
      </Box>
    )
  }
}

export default compose(
  WithSizes,
  injectIntl
)(Container)



// WEBPACK FOOTER //
// ./src/containers/landing/landing.container.js